import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import { TextsComponent } from '../texts/texts.component';
import { Location, NgIf } from '@angular/common';
import { SwitchComponent } from '../switch/switch.component';
import { ThemeService } from '../../../services/theme.service';
import { HeaderService } from '../../../services/header-service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationDto } from '../../../model/continent';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Text} from '../../../model/text';
import {FeedbackService} from '../../../services/feedback-service';
import {IconComponent} from '../icon/icon.component';
import {Icons} from '../../../model/icon';
import {scrollUp} from '../../../functions/scroll-up';

@Component({
  selector: 'app-title-background',
  imports: [TextsComponent, NgIf, SwitchComponent, IconComponent,],
  templateUrl: './title-background.component.html',
  standalone: true,
  styleUrl: './title-background.component.scss'
})
export class TitleBackgroundComponent implements OnInit, OnDestroy, OnChanges {
  constructor(
    protected themeService: ThemeService,
    private location: Location,
    protected interfaceService: HeaderService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    public feedValue: FeedbackService) {}

  @Input() map: boolean = false;
  @Input() portal: boolean = false;
  @Input() locationDto: LocationDto = new LocationDto();
  @Input() button?: boolean = false;
  @Input() hotelSection: boolean = false;
  @Input() mapSection: boolean = false;
  @Input() countdown?: number;
  @Input() link?: string;
  @Input() time?: number = 0;
  @Output() emitClick = new EventEmitter();

  alt: string = 'img';
  mapId: string | undefined = undefined;
  private cachedMapUrl: SafeResourceUrl | null = null;
  buttonText: Text[] = [{text: ['Исследовать ', 'Discover']}];
  showDestination: boolean = false;
  isMobile: boolean = false;

  ngOnInit() {
    if (window.innerWidth < 571) {
      this.isMobile = true
    }
    if (this.locationDto.destinationsText !== undefined) {
      this.showDestination = true
    }
    this.updateMapId();
    if (this.locationDto.titleBackgroundButtonText !== undefined) {
      this.buttonText = this.locationDto.titleBackgroundButtonText;
    }
    if (this.locationDto.button === undefined) {
      this.locationDto.button = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['locationDto']) {
      this.updateMapId();
      if (this.locationDto.button === undefined) {
        this.locationDto.button = true;
      }
      if (this.locationDto.titleBackgroundButtonText !== undefined) {
        this.buttonText = this.locationDto.titleBackgroundButtonText;
      }
    }
  }

  ngOnDestroy() {
    this.interfaceService.setRouteOpenMap(false);
  }

  private updateMapId() {
    if (this.locationDto.map !== undefined) {
      this.mapId = this.locationDto.map;
    }
  }

  getBackground(): string {
    if (!this.locationDto.image || this.locationDto.image === environment.s3Prefix) {
      return 'app/assets/images/middle-east.png';
    }
    if (this.locationDto.image.startsWith('/app/assets/') ||
      this.locationDto.image.startsWith('app/assets/')) {
      return this.locationDto.image;
    }
    return environment.s3Prefix + this.locationDto.image;
  }

  switchMap(value: boolean) {
    this.interfaceService.setRouteOpenMap(value);
  }

  onExploreClick() {
    if (this.locationDto.titleBackgroundButtonText === undefined) {
      this.emitClick.emit();
    } else {
      this.feedValue.setFeedbackValue([{text: ['Другое', 'Other']}]);
      this.router.navigate( [ '/feedback' ] ).then(r => r);
    }
  }

  getSafeMapUrl(mapId?: string): SafeResourceUrl {
    const id = mapId || this.mapId;
    if (!id) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }
    if (this.cachedMapUrl && id === this.mapId) {
      return this.cachedMapUrl;
    }
    const url = `https://snazzymaps.com/embed/${id}`;
    this.cachedMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    return this.cachedMapUrl;
  }

  replaceObjectPosition(cssString: string | undefined): string {
    if (cssString === undefined) {
      return '';
    }
    if (!cssString) {
      return 'filter: brightness(0.9);';
    }

    // Найти существующий filter в cssString
    const filterMatch = cssString.match(/filter:\s*([^;]+)/);

    if (filterMatch) {
      // Добавить brightness к существующему фильтру
      const newFilter = `${filterMatch[1]} brightness(0.9)`;
      return cssString
        .replace(/object-position/g, 'background-position')
        .replace(/filter:\s*[^;]+/, `filter: ${newFilter}`);
    } else {
      // Если фильтра нет, добавить его
      return cssString
        .replace(/object-position/g, 'background-position') + ' filter: brightness(0.9);';
    }
  }

  reserveHotel() {
    scrollUp();
    this.feedValue.setFeedbackValue([{text: ['Бронирование отелей', 'Hotel Booking']}]);
    this.router.navigate([ '/feedback' ]).then(r => r)
  }

  protected readonly Icons = Icons;
}
